"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getElementTop = function getElementTop(element) {
  if (element.pageYOffset) return element.pageYOffset;

  if (element.document) {
    if (element.document.documentElement && element.document.documentElement.scrollTop) return element.document.documentElement.scrollTop;
    if (element.document.body && element.document.body.scrollTop) return element.document.body.scrollTop;

    return 0;
  }

  return element.scrollY || element.scrollTop || 0;
};

exports.default = getElementTop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtual-list/lib/utils/getElementTop.js
// module id = 775
// module chunks = 1